module.exports = __webpack_public_path__ + "img/stock0.70cfef62.png";